import { Skeleton } from 'primereact/skeleton';
import React from 'react';

export const WorkingHoursLoadingTemplate = () => {
  return (
    <div>
      {Array.from({ length: 5 }).map((_, index) => (
        <div
          key={index}
          style={{ padding: '12px 0', display: 'flex', gap: '16px' }}
        >
          <Skeleton width="120px" height="20px" />
          <Skeleton width="120px" height="20px" />
          <Skeleton width="100px" height="20px" />
          <Skeleton width="150px" height="20px" />
          <Skeleton width="80px" height="20px" />
          <Skeleton width="100px" height="20px" />
          <Skeleton width="60px" height="20px" />
        </div>
      ))}
    </div>
  );
};
